export default "__VITE_ASSET__DG8jy0oX__"